import React, { Fragment } from "react";
import styled from "styled-components";
import { InsertDriveFile } from "@material-ui/icons";

import SecondaryButton from "./SecondaryButton";

const NotesButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <InsertDriveFile />
    <div>NOTES</div>
  </SecondaryButton>
);
export default NotesButton;
